export const MEMBER_DASHBOARD_LAYOUT_VERSION = 'v7';

export const MEMBER_DASHBOARD_GAMELOOP_ITEM_KEY = 'gameloopTags';

export const DEFAULT_MEMBER_DASHBOARD_LAYOUT = [
  // Top left Hero
  { i: 'hero', x: 0, y: 0, w: 6, h: 7, minW: 3, minH: 4 },

  // Top right — Assignment
  { i: 'gameloopTags', x: 6, y: 0, w: 6, h: 11, minW: 3, minH: 6 },
  
  // Below hero — Rank progression + Ribbons
  { i: 'rankHistory', x: 0, y: 9, w: 3, h: 8, minW: 2, minH: 5 },
  { i: 'trainings', x: 3, y: 9, w: 3, h: 8, minW: 3, minH: 5 },

  // Bellow assignments — Ribbons + History
  { i: 'ribbons', x: 6, y: 11, w: 6, h: 8, minW: 2, minH: 5 },
  { i: 'history', x: 6, y: 19, w: 6, h: 12, minW: 2, minH: 4 },

  // Remaining cards (below the core block; user can rearrange)
  { i: 'activity', x: 0, y: 19, w: 6, h: 8, minW: 4, minH: 6 },
  { i: 'eventsByName', x: 0, y: 29, w: 6, h: 8, minW: 4, minH: 6 },

];

export const MEMBER_DASHBOARD_DRAG_CANCEL =
  'button, select, input, textarea, a, label, .member-dashboard__gameloop-chip, .member-dashboard__gameloop-icon-btn, .member-dashboard__structure-comment-textarea, .member-dashboard__chart-year-select, .member-dashboard__ribbons-toolbar__btn, .member-dashboard__ribbon-info__btn, .member-dashboard__ribbon-handle__btn, .member-dashboard__history-loot-chip, .member-dashboard__history-row__link';

export const MEMBER_DASHBOARD_GRID_ROW_HEIGHT = 28;
export const MEMBER_DASHBOARD_GRID_MARGIN = [12, 12];

export function memberDashboardLayoutsEqual(
  layoutA,
  layoutB = DEFAULT_MEMBER_DASHBOARD_LAYOUT
) {
  if (!Array.isArray(layoutA) || !Array.isArray(layoutB)) return false;

  const byKey = Object.fromEntries(layoutB.map((item) => [item.i, item]));

  return layoutA.every((item) => {
    const other = byKey[item.i];
    if (!other) return false;
    return (
      Number(item.x) === Number(other.x) &&
      Number(item.y) === Number(other.y) &&
      Number(item.w) === Number(other.w) &&
      Number(item.h) === Number(other.h)
    );
  });
}

/** Convert measured content height (px) to react-grid-layout row count. */
export function pixelsToGridRows(pixelHeight, rowHeight = MEMBER_DASHBOARD_GRID_ROW_HEIGHT, margin = MEMBER_DASHBOARD_GRID_MARGIN) {
  const marginY = margin[1];
  if (!Number.isFinite(pixelHeight) || pixelHeight <= 0) return 1;
  return Math.max(1, Math.ceil((pixelHeight + marginY) / (rowHeight + marginY)));
}

function snapshotInlineBox(el) {
  return {
    el,
    height: el.style.height,
    minHeight: el.style.minHeight,
    maxHeight: el.style.maxHeight,
    overflow: el.style.overflow,
  };
}

function restoreInlineBox({ el, height, minHeight, maxHeight, overflow }) {
  el.style.height = height;
  el.style.minHeight = minHeight;
  el.style.maxHeight = maxHeight;
  el.style.overflow = overflow;
}

function measureChildrenBottom(el) {
  if (!el) return 0;
  const baseTop = el.getBoundingClientRect().top;
  let maxBottom = baseTop;

  for (const child of el.children) {
    const rect = child.getBoundingClientRect();
    if (rect.height <= 0) continue;
    maxBottom = Math.max(maxBottom, rect.bottom);
  }

  return Math.max(0, Math.ceil(maxBottom - baseTop));
}

/**
 * Measure gameloop card intrinsic height for grid row auto-grow.
 * Firefox under-reports scrollHeight when ancestors use overflow:visible + height:auto;
 * temporarily relax constraints on the measure chain, then restore inline styles.
 */
export function measureGameloopGridItemRows(
  bodyEl,
  rowHeight = MEMBER_DASHBOARD_GRID_ROW_HEIGHT,
  margin = MEMBER_DASHBOARD_GRID_MARGIN,
) {
  if (!bodyEl) return null;

  const cardEl = bodyEl.querySelector('.member-dashboard__gameloop-card');
  if (!cardEl) return null;

  const gridItemEl = bodyEl.closest('.react-grid-item');
  const chain = [gridItemEl, bodyEl, cardEl].filter(Boolean);
  const saved = chain.map((el) => snapshotInlineBox(el));

  for (const entry of saved) {
    entry.el.style.height = 'auto';
    entry.el.style.minHeight = '0';
    entry.el.style.maxHeight = 'none';
    entry.el.style.overflow = 'visible';
  }

  const pixelHeight = Math.max(
    cardEl.scrollHeight,
    cardEl.offsetHeight,
    cardEl.getBoundingClientRect().height,
    measureChildrenBottom(cardEl),
  );

  for (const entry of saved) {
    restoreInlineBox(entry);
  }

  return pixelsToGridRows(pixelHeight, rowHeight, margin);
}
